import { render, staticRenderFns } from "./CollectiveCard.vue?vue&type=template&id=91159aa2&scoped=true"
import script from "./CollectiveCard.vue?vue&type=script&lang=js"
export * from "./CollectiveCard.vue?vue&type=script&lang=js"
import style0 from "./CollectiveCard.vue?vue&type=style&index=0&id=91159aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91159aa2",
  null
  
)

export default component.exports